import axios from 'axios';
import { setTaxiEndpoint } from '../GetReservation';
import { ReservationParams } from './ReservationParams';

interface ApiConfig {
  baseURL: string;
  timeout: number;
}

const DEFAULT_API_CONFIG: ApiConfig = {
  baseURL: process.env['REACT_APP_API_ENDPOINT'] as string,
  timeout: 60000,
};

/** 本予約APIを呼び出す。 */
export async function submitReservation(params: ReservationParams) {
  try {
    const config = {
      ...DEFAULT_API_CONFIG,
    };
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    /** axiosのインスタンス。 */
    const instance = axios.create(config);
    /** 本予約APIのパス。 */
    const path = await setPath();
    // 本予約APIにPOSTメソッドでリクエストする。
    return await instance.post(path, {...params});
  } catch (err) {
    // エラーが発生した場合、nullを返す。
    return null;
  }
}

/** 環境に応じて呼び出すAPIのパスを切り替える。 */
async function setPath() {
  return setTaxiEndpoint('submit-reservation');
}
